import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from 'src/app/services/report.service';
import { GasTravel } from 'src/app/models/gas-travel';
import { from } from 'rxjs';
import { groupBy, mergeMap, reduce, filter } from 'rxjs/operators';
import { TravelService } from 'src/app/services/travel.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { InvoiceTicket } from '../../../../models/invoice-ticket';
import { AuthService } from '../../../../services/auth.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { InvoiceTicketService } from '../../../../services/invoice-ticket.service';

@Component({
  selector: 'app-gas-report-all',
  templateUrl: './gas-report-all.component.html',
  styleUrls: ['./gas-report-all.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class GasReportAllComponent implements OnInit {
  date1:Date = new Date();
  date2:Date = new Date();
  loading:boolean = false;

  data:GasTravel[] = [];
  original:GasTravel[] = [];

  total_proeco_d:number = 0;
  total_t26_d:number = 0;
  total_otro_d:number = 0;
  total_proeco_g:number = 0;
  total_t26_g:number = 0;
  total_otro_g:number = 0;
  total_proecocelaya_d:number = 0;
  total_proecocelaya_g:number = 0;

  unities:any[] = [];
  unityId = null;
  unitiesSelected:any[] = [];
  types:any[] = [];
  typesSelected:any[] = [];
  enterprise = null;
  enterprises:any[] = [];
  enterprisesSelected:any[] = [];

  expand:boolean = false;

  gasTravel:GasTravel = new GasTravel();
  //Empresas por tipo de carga
  type: string = null;
  gasType: string = null;
  companyType: GasTravel[];
  //Factura
  invoiceData: InvoiceTicket = new InvoiceTicket();
  totalTicketBatchMetric: number = 0;
  ticketSelected: number = 0;
  //Permiso "upload-invoice-data"
  public addInvoiceData: boolean = false;

  constructor(private repServ:ReportService, private modalService: NgbModal, private travelServ:TravelService, private toastr:ToastrManager, private authService:AuthService, private utl: UtilitiesService, private invoiceTicketService: InvoiceTicketService) { }

  ngOnInit() {
    this.addInvoiceData = this.authService.can('upload-invoice-data');
  }

  search() {
    this.loading = true;
    this.repServ.gasReportAll(this.date1, this.date2)
      .then(resp => {
        this.original = resp;
        this.groupData();
        this.filterData();
        this.loading = false;
        //Totales Diesel - Gasolina
        this.getTotalGas(this.original);
      });
  }

  getTotalGas(original: GasTravel[]){
    this.total_otro_d = original.filter(x => x.type == 'n/a' && x.gas_type == 'Diesel')
    .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_proeco_d = original.filter(x => x.type == 'proeco' && x.gas_type == 'Diesel')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_t26_d = original.filter(x => x.type == 't26' && x.gas_type == 'Diesel')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_proecocelaya_d = original.filter(x => x.type == 'proeco celaya' && x.gas_type == 'Diesel')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_otro_g = original.filter(x => x.type == 'n/a' && x.gas_type == 'Gasolina')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_proeco_g = original.filter(x => x.type == 'proeco' && x.gas_type == 'Gasolina')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_t26_g = original.filter(x => x.type == 't26' && x.gas_type == 'Gasolina')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
    this.total_proecocelaya_g = original.filter(x => x.type == 'proeco celaya' && x.gas_type == 'Gasolina')
      .reduce((ant, act) => Number(ant) + Number(act.metric_real), 0);
  }

  groupData() {
    this.types = [];
    this.unities = [];
    this.enterprises = [];

    from(this.original)
      .pipe(
        groupBy(x => x.type),
        mergeMap(x => x.pipe(reduce((ant, act) => act.type, null)))
      ).subscribe(x => this.types.push(x));

    from(this.original)
      .pipe(
        groupBy(x => x.unity_id),
        mergeMap(x => x.pipe(reduce((ant, act) => act.unity_id, null)))
      ).subscribe(x => this.unities.push(x));
    
    from(this.original)
      .pipe(
        groupBy(x => x.enterprise),
        mergeMap(x => x.pipe(reduce((ant, act) => act.enterprise, null)))
      ).subscribe(x => this.enterprises.push(x));
  }

  filterData () {
    this.data = [];

    from(this.original)
      .pipe(
        filter(x => this.hasData(x.unity_id, this.unitiesSelected) && this.hasData(x.type, this.typesSelected) && this.hasData(x.enterprise, this.enterprisesSelected)),
      ).subscribe(
        x => {
          if (this.data.length && this.data[this.data.length - 1].metric_final != x.metric_initial && x.metric_initial > 1) {
            this.data.push(new GasTravel);
          }
          this.data.push(x);
          this.getTotalGas(this.data);
        },
      );
  }

  addElement(element, whoArray) {
    if(element != 'null'){
      if (whoArray.indexOf(element) === -1) {
        whoArray.push(element);
        this.filterData();
      }
    }
  }

  removeElement(element, whoArray) {
    for (var i = 0; i < whoArray.length; i++) {
      if (whoArray[i] === element) {
        whoArray.splice(i, 1);
        break;
      }
    }

    this.filterData();
  }

  hasData(value, array) {
    if (array.length == 0) {
      return true;
    }

    for (let i = 0; i < array.length; i++) {
      if (array[i] == value) {
        return true;
      }
    }
    return false;
  }

  openModal(modal, type1 = null, type2 = null){
    this.companyType = [];
    this.modalService.open(modal, { size: 'lg', centered: true });
    if(type2 == 'Diesel'){
      this.type = (type1 == 'n/a') ? 'Otros' : type1;
      this.gasType = type2;
      this.companyType = _.filter(this.data, function(o){
        return o.gas_type == type2 && o.type == type1;
      });
      this.companyType = _.uniqBy(this.companyType, 'enterprise');
    }else if(type2 == 'Gasolina'){
      this.type = (type1 == 'n/a') ? 'Otros' : type1;
      this.gasType = type2;
      this.companyType = _.filter(this.data, function(o){
        return o.gas_type == type2 && o.type == type1;
      });
      this.companyType = _.uniqBy(this.companyType, 'enterprise');
    }

    this.totalTicketBatchMetric = _.sumBy(this.invoiceData.gastickets, x => Number(x.metric_real));
    this.invoiceData.iva = Number(0.16);
  }

  totalLoadByCompany(gasTravel: GasTravel){
    return this.data.filter(e => e.gas_type == gasTravel.gas_type && e.type == gasTravel.type && e.enterprise == gasTravel.enterprise).reduce((ant, act)=>Number(ant) + Number(act.metric_real), 0);
  }

  download(type){
    window.open(environment.baseUrl + '/' + type + '/gas/all?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&unities=' + this.unitiesSelected + '&types=' + this.typesSelected + '&enterprises=' + this.enterprisesSelected, '_blank')
  }

  deleteGasTravel(){
    if (!this.gasTravel.sap_code) {
      this.loading = true;
      this.travelServ.deleteGasTravel(this.gasTravel).subscribe(resp=>{
        this.data = this.data.filter(d => d.id != this.gasTravel.id);
        this.gasTravel.id = 0;
        this.gasTravel.gasticket = 0;
        this.toastr.successToastr("Viaje eliminado correctamente.");
        this.modalService.dismissAll();
        this.loading = false;
      },error=>{
        this.toastr.errorToastr("No se pudo eliminar el viaje.");
        this.loading = false;
      });
    } else {
      this.toastr.infoToastr("Ya sea ha cargado a SAP, es imposible eliminarlo, verificalo con el juanito.");
    }
  }

  selectedTickets(gt: GasTravel){
    //Revisamos si el ticket ya esta agregado, sino lo agregamos
    if(!this.invoiceData.gastickets.includes(gt)){
      this.invoiceData.gastickets.push(gt);
    }else{
      //Para saber en posicion esta el elemento a eliminar
      let i = this.invoiceData.gastickets.indexOf(gt);
      if(i !== -1 ){
        this.invoiceData.gastickets.splice(i, 1);
      }
    }
  }

  saveInvoiceData(){
    this.invoiceTicketService.saveInvoiceData(this.invoiceData).subscribe(response => {
      this.search();
      this.loading = false;
      this.modalService.dismissAll();
      this.invoiceData = new InvoiceTicket();
      this.invoiceData.iva = Number(0.16);
      this.toastr.successToastr("Factura " + response.invoice_number + " creada correctamente");
    },error=>{
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML:true});
    });
  }

  getTotal(event){
    if(event.target.value)
      this.invoiceData.total = ((Number(this.invoiceData.subtotal) * Number(this.invoiceData.iva)) + Number(this.invoiceData.subtotal));
    else
      this.invoiceData.total = 0;
  }

  errorDeleteModal(modal, gasTravel: GasTravel){
    this.ticketSelected = gasTravel.gasticket;
    this.modalService.open(modal, { size: 'lg', centered: true });
  }
}
